import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback } from 'react';
import { EXPORT_SEARCH_API_PREFIX } from '../constants';
import { useExportsMetadataStore } from '../store/exports-metadata';
import {
  BrowseSearchExportsRequest,
  BrowseSearchExportsResponse,
} from './types';

export function useBrowseSearchExports(request: BrowseSearchExportsRequest) {
  const workspace = useWorkspace()?.id;
  request.page = request.page || 0;
  request.size = request.size || 10;

  const { visibility, grouping, name, page, size, sort, status, id } = request;

  const { setMetadata } = useExportsMetadataStore();

  return useBaseQuery<BrowseSearchExportsRequest, BrowseSearchExportsResponse>(
    [
      useBrowseSearchExports.name,
      visibility,
      grouping,
      name,
      page,
      size,
      sort,
      status,
      id,
    ],
    {
      url: EXPORT_SEARCH_API_PREFIX.replace(':wid', String(workspace)),
      params: {
        visibility,
        grouping,
        name,
        page,
        size,
        sort,
        status,
        id,
      },
    },
    {
      enabled: !!request.grouping || !!request.id,
      select: useCallback(
        (data: BrowseSearchExportsResponse) => {
          setMetadata(data.metadata);
          return data;
        },
        [visibility, grouping, name, page, size, sort, status]
      ),
    }
  );
}
